import React from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from 'antd';
import { get } from 'lodash';
import { CDN_ACCOUNT_TYPE } from '@utils/constants';
import {
  aiBrokenAssetsSelector,
  accountTypeSelector,
  aiNewappVersionSelector,
} from '@store/common/selectors';
import { StyledDrawer } from '../styled';
import Alert from './Alert';
import BrokenAssets from './BrokenAssets';
import NewAppVersion from './NewAppVersion';
import { useFetchSettings } from './hooks';
import LoaderHoc from './LoaderHoc';

const { Panel } = Collapse;

export enum SettingTypes {
  alertInsights = 'alert-insights',
  brokenAssests = 'broken-assests',
  lowCohorts = 'low-cohorts',
  appVersionPerf = 'newapp-version',
}

function SettingsDrawer({ closeSettings, visible }) {
  const { isLoading, data } = useFetchSettings();
  const { settings = {} } = get(data, 'data', {});
  const aiBrokenAssets = useSelector(aiBrokenAssetsSelector);
  const customerAccountType = useSelector(accountTypeSelector);
  const aiNewappVersion = useSelector(aiNewappVersionSelector);

  return (
    <StyledDrawer
      title="Settings"
      placement="right"
      closable={true}
      onClose={closeSettings}
      open={visible}
      key="settings-drawer"
      mask={true}
      width={400}
      destroyOnHidden={true}
    >
      <Collapse
        bordered={false}
        defaultActiveKey={['alert-insights', 'broken-assets', 'newapp-version', 'cohorts']}
      >
        {customerAccountType !== CDN_ACCOUNT_TYPE && aiNewappVersion ? (
          <Panel header={<div>{'New App Version'}</div>} key="newapp-version">
            <LoaderHoc isLoading={isLoading}>
              <NewAppVersion data={settings[SettingTypes.appVersionPerf]} />
            </LoaderHoc>
          </Panel>
        ) : (
          ''
        )}
        {customerAccountType !== CDN_ACCOUNT_TYPE && aiBrokenAssets ? (
          <Panel header={<div>{'Broken Assets'}</div>} key="broken-assets">
            <LoaderHoc isLoading={isLoading}>
              <BrokenAssets data={settings[SettingTypes.brokenAssests]} />
            </LoaderHoc>
          </Panel>
        ) : (
          ''
        )}
        <Panel header={<div>{'Alert Insights'}</div>} key="alert-insights">
          <LoaderHoc isLoading={isLoading}>
            <Alert data={settings[SettingTypes.alertInsights]} />
          </LoaderHoc>
        </Panel>

        {/*
        <Panel
          header="Underperforming Cohorts"
          key="cohorts"
        >
          <LoaderHoc isLoading={isLoading}>
            <Cohorts data={settings[SettingTypes.lowCohorts]} />
          </LoaderHoc>
        </Panel>
        */}
      </Collapse>
    </StyledDrawer>
  );
}

export default SettingsDrawer;
